// import { fadeInOnView } from "../lib/fade-in-on-view.module";

import { $, $$ } from "./lib/$.module";
import { inView } from "./lib/in-view.module";
import { scrollAct, scrollDirection } from "./lib/scroll-act.module";

{
    
    const page = () => document.documentElement;
    const header = () => $('.page-header');
    const menu = () => $('.page-header-menu');
    const meta = () => $('.page-header-meta');
    const noStickyContent = parent => $$('.main-navigation', parent);
    const logo = () => {
        const div = document.createElement('div');
        const aOrig = document.querySelector('.page-header-logo a')
        div.classList.add('page-header-sticky-logo');
        const a = document.createElement('a')
        const names = aOrig.getAttributeNames();
        for (n of names) {
            a.setAttribute(n, aOrig.getAttribute(n))
        }
        const img = document.createElement('img');
        img.setAttribute('src', '/typo3conf/ext/sitepackage/Resources/Public/Assets/Images/logo-naturhotel-laerchenhof-black.svg');
        img.setAttribute('width', '308');
        img.setAttribute('height', '84');
        img.setAttribute('alt', 'Logo');
        div.appendChild(a)
        a.appendChild(img)
        return div;
    }

    let firstRun = true;

    const cloneSticky = () => {
        const c = document.createElement('div');
        c.classList.add('sticky-header')
        c.appendChild(menu().cloneNode(true))
        c.appendChild(logo());
        c.appendChild(meta().cloneNode(true))
        noStickyContent(c).forEach(nsc => nsc.remove());
        document.body.appendChild(c)
    }

    const onScrolldown = e => {
        document.documentElement.classList.add('scrolldown')
        document.documentElement.classList.remove('scrollup')

        
        if (!inView(menu()) && !inView(meta())) {
            if (firstRun) {
                firstRun = false;
                cloneSticky()
            }

            page().classList.add('sticky')
            page().classList.remove('static')
        }
    }

    const onScrollup = e => {
        document.documentElement.classList.add('scrollup')
        document.documentElement.classList.remove('scrolldown')
        if (inView(menu()) || inView(meta())) {
            page().classList.add('static')
            page().classList.remove('sticky')
        }
    }

    scrollDirection()

    document.addEventListener('scrolldown', onScrolldown)
    document.addEventListener('scrollup', onScrollup)
}

